//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObjectCollection.js";
import "../Features/Features.FeatureCollection.js";
let d=[[],[[["attributeName","attributeProperties"],"CreateCustomTagAttribute",{R_:{attribute:"Features.CustomTagAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomTagArrayAttribute",{R_:{attribute:"Features.CustomTagArrayAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomStringAttribute",{R_:{attribute:"Features.CustomStringAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomStringArrayAttribute",{R_:{attribute:"Features.CustomStringArrayAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomLogicalAttribute",{R_:{attribute:"Features.CustomLogicalAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomLogicalArrayAttribute",{R_:{attribute:"Features.CustomLogicalArrayAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomIntegerAttribute",{R_:{attribute:"Features.CustomIntegerAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomIntegerArrayAttribute",{R_:{attribute:"Features.CustomIntegerArrayAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomExpressionAttribute",{R_:{attribute:"Features.CustomExpressionAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomExpressionArrayAttribute",{R_:{attribute:"Features.CustomExpressionArrayAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomDoubleAttribute",{R_:{attribute:"Features.CustomDoubleAttribute"}},2,0],[["attributeName","attributeProperties"],"CreateCustomDoubleArrayAttribute",{R_:{attribute:"Features.CustomDoubleArrayAttribute"}},2,0]],[]];
SPLM.Features.CustomAttributeCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.CustomAttributeCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;